import { API_URL, API_URL_DEV,API_URL_LOCAL_DEV } from "../../env";
import { Get, Post } from "../consumir";

interface SaveSuscriptionPaypalInformationProps {
  paypalresponse: any;
  iduser: number;
  fecha: Date;
  plan: string;
  subscriptionNumber: number;
}

interface CreateSubscription {
  id: string;
  player_id: number;
  start_subscription: Date;
  reason: string;
  data: any[];
  updateType?: string | 'subscription' | 'update' | 'cancel';
  recurring_type?:'monthly'|'yearly';
}
interface CancelSubscription {
  id: string;
  player_id: number;
  paypalData:any[];
  fecha: Date;
  status: string;
  paymentProvider: string;
}
const API_CALL = API_URL;

export const createSubscriptionPaypal = async (data:CreateSubscription) => {
  try {
    const response = await Post(
      `${API_CALL}/subscriptions/paypal/create-subscription`,data
    );
    return response.data;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION TO CREATE SUBSCRIPTION", error);
  }
};
export const SaveSuscriptionPaypalInformation = async (
  data: SaveSuscriptionPaypalInformationProps
) => {
  try {
    const response = await Post(
      `${API_CALL}/subscriptions/SavePaypalResponse/`,
      data
    );

    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION  SEND INFO PAYPAL", error);
  }
};

export const cancelSubscriptionPaypal = async ({
  id,
  player_id,
  paypalData,
  fecha,
  status,
  paymentProvider,
}:CancelSubscription) => {
  try {
    const values = {
      id,
      player_id,
      paypalData,
      fecha,
      status,
      paymentProvider,
    };
    const response = await Post(
      `${API_CALL}/subscriptions/cancel`,
      values
    );

    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION TO CANCEL SUSCRIPTION", error);
  }
};

export const updateMemberShip = async (userId: number, membership: number) => {
  try {
    const response = await Get(
      `${API_CALL}/subscriptions/updatePlan/${userId}/${membership}`
    );

    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION UPDATE SUSCRIPTION", error);
  }
};

export const getInfoUserPaypal = async (userId: number) => {
  try {
    const response = await Get(
      `${API_CALL}/subscriptions/getPaypalResponse/${userId}`
    );

    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION TO GET INFO USER", error);
  }
};

export const statusSubscriptionUser = async (userId: number) => {
  try {
    const response = await Get(`${API_CALL}/subscriptions/subStatus/${userId}`);

    return response;
  } catch (error) {
    console.error(
      "ERROR NETWORK CONNECTION TO GET STATUS MEMBERSHIP USER",
      error
    );
  }
};
